<!-- src/components/MedicamentoSelect.vue -->
<template>
  <div class="position-relative" ref="wrapper">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :placeholder="placeholder"
        v-model="query"
        @input="onInput"
        @focus="abrirDropdown"
        autocomplete="off"
      />
      <span class="input-group-text">
        <span v-if="cargando" class="spinner-border spinner-border-sm"></span>
        <i v-else class="material-icons" style="font-size:18px">search</i>
      </span>
    </div>

    <!-- Selección actual -->
    <div v-if="seleccionado" class="mt-1 d-flex align-items-center gap-2">
      <span class="badge bg-primary">{{ seleccionado.nombre }}</span>
      <button type="button" class="btn btn-sm btn-link p-0 text-danger"
              @click="limpiar()">
        <i class="material-icons" style="font-size:16px">close</i>
      </button>
    </div>

    <!-- Dropdown de resultados -->
    <ul v-if="mostrarDropdown && resultados.length"
        class="dropdown-resultados list-unstyled shadow">
      <li v-for="item in resultados" :key="item.idElemento"
          class="dropdown-item-med"
          @mousedown.prevent="seleccionar(item)">
        <span class="fw-bold">{{ item.nombre }}</span>
        <small class="text-muted ms-2">{{ item.codigo }}</small>
      </li>
    </ul>

    <div v-if="mostrarDropdown && !resultados.length && !cargando && query.length >= minChars"
         class="dropdown-resultados text-muted small p-2">
      Sin resultados
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'MedicamentoSelect',
  emits: ['update:modelValue', 'seleccionado'],
  props: {
    modelValue:  { type: Number, default: null },
    placeholder: { type: String, default: 'Buscar medicamento...' },
    minChars:    { type: Number, default: 2 },
    tipoElem:    { type: Number, default: 2 },   // 2 = medicamentos
  },
  data() {
    return {
      query:           '',
      resultados:      [],
      seleccionado:    null,
      cargando:        false,
      mostrarDropdown: false,
      timer:           null,
    }
  },
  watch: {
    // Si el padre asigna un valor inicial, cargamos el nombre
    modelValue: {
      immediate: true,
      async handler(val) {
        if (val && (!this.seleccionado || this.seleccionado.idElemento !== val)) {
          try {
            const { data } = await api.get(`/vwelementos/${val}`)
            this.seleccionado = data
            this.query        = ''
          } catch { /* silencioso */ }
        }
        if (!val) { this.seleccionado = null; this.query = '' }
      }
    }
  },
  methods: {
    onInput() {
      clearTimeout(this.timer)
      if (this.query.length < this.minChars) {
        this.resultados      = []
        this.mostrarDropdown = false
        return
      }
      this.cargando = true
      // Debounce 350 ms
      this.timer = setTimeout(() => this.buscar(), 350)
    },

    async buscar() {
      try {
        const { data } = await api.get(
          `/vwelementos/buscar?nombre=${encodeURIComponent(this.query)}&idTipoElem=${this.tipoElem}&limit=20`
        )
        this.resultados      = data
        this.mostrarDropdown = true
      } catch {
        this.resultados = []
      } finally {
        this.cargando = false
      }
    },

    seleccionar(item) {
      this.seleccionado    = item
      this.query           = ''
      this.mostrarDropdown = false
      this.$emit('update:modelValue', item.idElemento)
      this.$emit('seleccionado', item)
    },

    limpiar() {
      this.seleccionado    = null
      this.query           = ''
      this.resultados      = []
      this.mostrarDropdown = false
      this.$emit('update:modelValue', null)
      this.$emit('seleccionado', null)
    },

    abrirDropdown() {
      if (this.resultados.length) this.mostrarDropdown = true
    },

    cerrarDropdown() {
      this.mostrarDropdown = false
    },
  },

  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$refs.wrapper?.contains(e.target)) this.cerrarDropdown()
    })
  },

  beforeUnmount() {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.dropdown-resultados {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1050;
  background-color: #ffffff;        /* blanco sólido */
  border: 1px solid #dee2e6;        /* gris Bootstrap */
  border-radius: 0.375rem;
  max-height: 240px;
  overflow-y: auto;
  margin-top: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dropdown-item-med {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f3f5;
}

.dropdown-item-med:last-child {
  border-bottom: none;
}

.dropdown-item-med:hover {
  background-color: #f8f9fa;        /* --bs-gray-100 */
}
</style>